module.exports = __webpack_public_path__ + "static/33F324_6_0-30497e16c52168a6337a2a791fc2e7a6.woff2";